import { Box, HStack, Heading, Text, VStack } from "@chakra-ui/react"
import UserAvatar from "@pathwright/ux/src/components/avatar/UserAvatar"
import { HomeResourceFragment, UserFragment } from "../../../api/generated"
import { PathCardBackground } from "../pathCard/PathCard"
import SimpleButton from "../ui/SimpleButton"

type AddPathPromptItem = {
  pathName: string
  pathBackground?: Pick<
    HomeResourceFragment,
    | "background_image"
    | "cover_image"
    | "background_type"
    | "background_overlay"
  >
  user?: UserFragment
}

export type AddPathPromptCardProps = {
  item: AddPathPromptItem
  isSubmitting?: boolean
  onSubmit: () => Promise<void>
  onCancel: () => Promise<void> | void
}

function AddPathPromptCard({
  item,
  isSubmitting,
  onSubmit,
  onCancel
}: AddPathPromptCardProps) {
  return (
    <VStack
      className="group"
      w="full"
      bg="rgba(26, 32, 44, 0.33)"
      backdropFilter="blur(20px)"
      borderRadius="20px"
      p={8}
      _hover={{
        bg: "rgba(26, 32, 44, 0.38)"
      }}
    >
      {!!item.pathBackground && (
        <Box
          opacity={isSubmitting ? 1 : 0}
          _groupHover={{ opacity: 1 }}
          transition="opacity 0.3s ease"
        >
          <PathCardBackground resource={item.pathBackground} />
        </Box>
      )}
      {!!item.user && (
        <HStack>
          <UserAvatar user={item.user} />
          <Text as="strong">{item.user.display_name}</Text>
          <Text as="span">invited you to</Text>
        </HStack>
      )}
      <VStack w="full">
        <Heading
          as="h2"
          size="h5"
          color="whiteAlpha.900"
          fontWeight="bold"
          noOfLines={2}
          m={0}
          w="full"
          pos="relative"
          zIndex={1}
        >
          {item.pathName}
        </Heading>
        <HStack w="full">
          {item.user ? (
            <SimpleButton
              rightIcon="chevron-right"
              label="Join"
              loadingText="Join..."
              isLoading={isSubmitting}
              onClick={onSubmit}
            />
          ) : (
            <SimpleButton
              leftIcon="plus"
              label="Add Path"
              loadingText="Adding Path..."
              isLoading={isSubmitting}
              onClick={onSubmit}
            />
          )}
          {!isSubmitting && (
            <SimpleButton
              variant="ghost"
              leftIcon="x"
              label="Not now"
              onClick={onCancel}
              p={2}
              // bg="transparent"
              backdropFilter="none"
              textDecor="underline"
              color="whiteAlpha.900"
            />
          )}
        </HStack>
      </VStack>
    </VStack>
  )
}

export default AddPathPromptCard
